// src/App.js
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes } from 'react-router-dom';

import PageLoader from './components/PageLoader';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import { ToastContainer } from 'react-toastify';

import publicRoutes from './routes/publicRoutes';
import protectedRoutes from './routes/protectedRoutes';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <ToastContainer />

      <main id="main-content">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {publicRoutes}
            {protectedRoutes}
          </Routes>
        </Suspense>
      </main>

      <Footer />
    </Router>
  );
}

export default App;
